import merge from 'deepmerge';
import { removeClass } from '../../helpers';

export default class CopyFormDefaultValue {
    constructor(defaultValue, copyBlock, copyButton, options = {}) {
        this.defaultValue = defaultValue;
        this.copyBlock = copyBlock;
        this.copyButton = copyButton;

        this.options = merge({
            classList: {
                copyBlock: 'js-block-to-copy',
                copyDiscipline: 'js-copy-discipline',
                copyBlockDiscipline: 'js-block-to-copy-discipline',

            },
        }, options);

        this._setDefaultValue();
    }

    _setDefaultValueToField(field, valueToSet) {
        const fieldType = field.getAttribute('type');

        if (fieldType === 'checkbox' || fieldType === 'radio') {
            field.checked = true;
            field.setAttribute('checked', 'true');
        }

        field.value = valueToSet;
        field.dispatchEvent(new Event('change'));
    }

    _setDefaultValueToCopyElement(copyEl, valueObject) {
        Object.keys(valueObject).forEach((key) => {
            const field = copyEl.querySelector(`[name="${key}"]`);

            if (field) {
                setTimeout(() => {
                    this._setDefaultValueToField(field, valueObject[key]);
                });
            }  
        });
    }

    _manageCopyElementsCount(copyCount, copyButton, selector, copyBlock) {
        for (let i = 1; i < copyCount; i++) {
            copyButton.dispatchEvent(new Event('click'));
        }

        return [...copyBlock.querySelectorAll(selector)];
    }

    _manageAjiPassportValidation(copyElement) {
        const validateButtons = [...copyElement.querySelectorAll('[data-aji-btn]')];
        setTimeout(() => {
            validateButtons.forEach((button) => {
                button.removeAttribute('disabled');
                removeClass(button, 'is-hidden-i');
                button.dispatchEvent(new Event('click'));
            });
        }, 0);
    }

    _setDefaultValue() {
        const { copyBlock: copyBlockClass, copyDiscipline: copyDisciplineClass, copyBlockDiscipline: copyBlockDisciplineClass } = this.options.classList;

        const mainCopyElements = this._manageCopyElementsCount(this.defaultValue.length, this.copyButton, `.${copyBlockClass}`, this.copyBlock);

        mainCopyElements.forEach((el, index) => {
            this._setDefaultValueToCopyElement(el, this.defaultValue[index]);
            this._manageAjiPassportValidation(el);

            const disciplineCopyArray = [...el.querySelectorAll(`.${copyDisciplineClass}`)];
            
            disciplineCopyArray.forEach((disciplineCopy) => {
                const dist = this.defaultValue[index].dist;

                if (!dist || !dist.length) {
                    return;
                }

                const disciplineCopyButtonID = disciplineCopy.getAttribute('data-copy-button-id');
                const disciplineCopyButton = document.querySelector(`#${disciplineCopyButtonID}`);
                const disciplineCopyElements = this._manageCopyElementsCount(dist.length, disciplineCopyButton, `.${copyBlockDisciplineClass}`, disciplineCopy);

                disciplineCopyElements.forEach((disciplineEl, distIndex) => {
                    this._setDefaultValueToCopyElement(disciplineEl, dist[distIndex]);
                });
            });
        });
    }
}
